import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Acesso} from "src/app/core/acesso";
import {CarregarPerfil} from "src/app/core/carregar-perfil";
import {ToastService} from "src/app/services/toast/toast.service";
import {EixoService} from "../../../services/eixo/eixo.service";
import {Eixo} from "../../../core/eixo";

@Component({
    selector: "cadastrar-eixo",
    templateUrl: "./cadastrar-eixo.component.html",
    styleUrls: ["./cadastrar-eixo.component.css"],
})
export class CadastrarEixoComponent implements OnInit {
    eixo: Eixo;

    perfilAcesso: Acesso = new Acesso();
    carregarPerfil: CarregarPerfil = new CarregarPerfil();

    mostrarBotaoCadastrar = true;
    mostrarBotaoAtualizar = true;

    isAtualizar: boolean = false;

    constructor(
        private eixoService: EixoService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private toastService: ToastService
    ) {
    }

    ngOnInit() {
        this.inicializarObjetos();

        this.carregarPerfil.carregar(
            this.activatedRoute.snapshot.data.perfilAcesso,
            this.perfilAcesso
        );

        if (!this.perfilAcesso.insere) {
            this.mostrarBotaoCadastrar = false;
        }

        if (!this.perfilAcesso.altera) {
            this.mostrarBotaoAtualizar = false;
        }

        const id = this.activatedRoute.snapshot.queryParams.id
            ? this.activatedRoute.snapshot.queryParams.id
            : null;
        if (id) {
            this.isAtualizar = true;
            this.eixoService
                .getById(id)
                .subscribe((eixo: Eixo) => {
                    this.eixo = eixo;
                });
        }
    }

    inicializarObjetos() {
        this.eixo = new Eixo();
    }

    mostrarBotaoLimpar() {
        if (this.isAtualizar) return false;
        if (!this.mostrarBotaoAtualizar) return false;
        if (!this.mostrarBotaoCadastrar) return false;

        return true;
    }

    cadastrar() {
        this.eixoService.cadastrar(this.eixo).subscribe(() => {
            this.toastService.showSucesso("Cadastro realizado com sucesso");
            this.router.navigate(["eixo"]);
        });
    }

    limpar() {
        this.inicializarObjetos();
        this.eixo.descricao = null;
    }

    cancelar() {
        this.router.navigate(["eixo"]);
    }

    atualizar() {
        this.eixoService.alterar(this.eixo).subscribe(() => {
            this.toastService.showSucesso("Registro atualizado com sucesso");
        });
    }

    camposDesabilitados() {
        if (this.isAtualizar) {
            return !this.perfilAcesso.altera;
        }
        return !this.perfilAcesso.insere;
    }
}
